export default __webpack_public_path__ + "static/media/utp.5f56db82.svg";